import { intRandom, customRandom } from './_randNum';
import { getRange } from './_getRange';
import { hoverDynamic } from './hover';

export function home() {
  const container = document.querySelector('.js-home-gallery');

  if (container && typeof images_json !== 'undefined') {
    let ww = window.document.documentElement.clientWidth;
    let isAnimate = true;
    let isTransition = false;

    const baseWidth = 1440; // 基準となるウィンドウの幅
  
    const minSize = 10;
    const maxSize = 30;
    const minSizeRatio = 2; // 最小サイズの最小調整率
    const maxSizeRatio = 2; // 最大サイズの最小調整率
    let [adjustedMinSize, adjustedMaxSize] = getRange(minSize, maxSize, '', '', ww, baseWidth, minSizeRatio, maxSizeRatio);
  
    const minSpeed = 1;
    const maxSpeed = 1.5;
    const minSpeedRatio = 0.7; // 最小サイズの最小調整率
    const maxSpeedRatio = 0.7; // 最大サイズの最小調整率
    let [adjustedMinSpeed, adjustedMaxSpeed] = getRange(minSpeed, maxSpeed, '', '', ww, baseWidth, minSpeedRatio, maxSpeedRatio);
  
    const minTiming = 3000;
    const maxTiming = 5000;
    const minTimingLimit = 3000;
    const maxTimingLimit = 5000;
    const minTimingRatio = 0.8; // 最小タイミングの最小調整率
    const maxTimingRatio = 0.6; // 最大タイミングの最小調整率
    let [adjustedMinTiming, adjustedMaxTiming] = getRange(minTiming, maxTiming, minTimingLimit, maxTimingLimit, ww, baseWidth, minTimingRatio, maxTimingRatio);

    const randoms = [];
    const randomsNum = images_json.images.length - 1;
    let current = randomsNum;
    const posts = [];
    const colors = [];

    const activeColorMinSpeed = 0.5;
    const activeColorMaxSpeed = 2;
    let activeColorObjects = [];

    const createColor = (post, color) => {
      const el = document.createElement('div');
      const _el = document.createElement('span');
      el.classList.add('color');
      el.setAttribute('data-ratio', customRandom(-0.08, 0.08, 3))
      el.style.top = `${intRandom(-10,110)}%`
      el.style.left = `${intRandom(-10,110)}%`
      _el.style.backgroundColor = color;
      _el.style.animation = `scale ${intRandom(5000,10000)}ms linear ${intRandom(100,1000)}ms infinite`;
      el.appendChild(_el)
      post.appendChild(el);
      colors.push(el);
    }

    const createActiveColor = (color) => {
      const cW = container.clientWidth;
      const cH = container.clientHeight;
      const range = 0.3;
      
      const el = document.createElement('span');
      el.classList.add('color-active');
      el.style.backgroundColor = color;
      container.appendChild(el);

      // 中心位置を計算
      const centerX = cW / 2;
      const centerY = cH / 2;

      // 中心からの距離（range%の範囲）を計算
      const rangeX = centerX * range;
      const rangeY = centerY * range;

      const left = (Math.random() * 2 - 1) * rangeX + centerX;
      const top = (Math.random() * 2 - 1) * rangeY + centerY;
      el.style.transform = `translate(${left}px, ${top}px)`;

      // スピードは一定にする
      const speed = Math.random() * (activeColorMaxSpeed - activeColorMinSpeed) + activeColorMinSpeed;

      // 角度は水平または垂直を除く
      const angle = Math.random() * 2 * Math.PI;
      const dx = speed * Math.floor(Math.cos(angle));
      const dy = speed * Math.floor(Math.sin(angle));
      const obj = { el, dx, dy };
      activeColorObjects.push(obj);
    }

    const createPost = (currentObj) => {
      const post = document.createElement('a');
      const img = document.createElement('img');
      post.setAttribute('href', currentObj.image_big);
      img.setAttribute('src', currentObj.image);
      img.classList.add('image');
      const posTop = `${intRandom(-15, 80)}`;
      const zIndex = `${intRandom(0, 100)}`;
      post.style.top = `${posTop}%`;
      post.style.zIndex = zIndex;
      post.classList.add('post');
      hoverDynamic(post);
      clickPost(post);

      const colors = currentObj.colors_hex;
      if(colors.length) {
        colors.forEach((color) => {
          createColor (post,color)
        })
      }

      post.style.width = `${intRandom(adjustedMinSize, adjustedMaxSize)}%`;
      post.appendChild(img);
      container.appendChild(post);
      post.setAttribute('data-ratio', customRandom(adjustedMinSpeed, adjustedMaxSpeed, 3))
      post.setAttribute('data-width', post.clientWidth)
      posts.push(post);
      
      img.onload = () => {
        post.classList.add('loaded');
      }
    }

    const clickPost = (post) => {
      post.addEventListener('click', (e) => {
        e.preventDefault();
        if(!isTransition) {
          isTransition = true;
          if(post.classList.contains('is-active')) {
            document.body.classList.remove('is-home-image-zoom');
            post.classList.add('is-hidden')
            const images = post.querySelectorAll('.image');
            if(images.length){
              images.forEach((image) => {
                image.classList.add('is-hidden')
              })
            }
            setTimeout(() => {
              post.classList.remove('is-active');
              posts.forEach((el) => {
                el.classList.remove('is-active', 'is-hidden')
                const els = document.querySelectorAll('.image, .color');
                if(els.length){
                  els.forEach((el) => {
                    setTimeout(() => {
                      el.classList.remove('is-hidden')
                    }, intRandom(0, 2000))
                  })
                }
              })
              isAnimate = true;
              setTimeout(() => {
                isTransition = false;
              }, 2000)
            }, 250);
            activeColorObjects.forEach(obj => container.removeChild(obj.el));
            activeColorObjects = [];
          } else {
            isAnimate = false;
            isTransition = false;
            document.body.classList.add('is-home-image-zoom');
            const searchValue = post.getAttribute('href')
            const filteredArray = images_json.images.filter(item => item['image_big'] === searchValue);
            const filteredColors = filteredArray[0].colors_hex
            if(filteredColors.length) {
              filteredColors.forEach((color) => {
                createActiveColor(color)
              })
            }
            posts.forEach((el) => {
              el.classList.remove('is-active');
              el.classList.add('is-hidden')
              const els = el.querySelectorAll('.image, .color');
              if(els.length){
                els.forEach((image) => {
                  image.classList.add('is-hidden')
                })
              }
            });
            setTimeout(() => {
              post.classList.remove('is-hidden')
              post.classList.add('is-active');
              const images = post.querySelectorAll('.image');
              if(images.length){
                images.forEach((_el) => {
                  _el.classList.remove('is-hidden')
                })
              }
            }, 250)
          }
        }
      });
    }

    const animateActiveColor = () => {
      if(activeColorObjects.length) {
        activeColorObjects.forEach((obj) => {
          const rect = obj.el.getBoundingClientRect();
          const containerRect = container.getBoundingClientRect();
          if (rect.left + obj.dx < containerRect.left || rect.right + obj.dx > containerRect.right) {
            obj.dx *= -1;
          }
          if (rect.top + obj.dy < containerRect.top || rect.bottom + obj.dy > containerRect.bottom) {
            obj.dy *= -1;
          }
          if (obj.dx === 0) obj.dx = 1;
          if (obj.dy === 0) obj.dy = 1;
          const left = (rect.left - containerRect.left) + obj.dx;
          const top = (rect.top - containerRect.top) + obj.dy;
          obj.el.style.transform = `translate(${left}px, ${top}px)`;
        })
      }
      requestAnimationFrame(animateActiveColor);
    }

    const animatePosts = () => {
      if(focus && isAnimate) {
        if(posts.length) {
          posts.forEach((post) => {
            const end = ww*1.2 + parseFloat(post.getAttribute('data-width'));
            const matrix = new WebKitCSSMatrix(window.getComputedStyle(post).transform);
            const param = matrix.m41 - parseFloat(post.getAttribute('data-ratio'));
            post.style.transform = `translateX(${param}px) translateZ(0)`;

            if (-param >= end) {
              const _colors = post.querySelectorAll('.color')
              if(_colors.length) {
                _colors.forEach((color) => {
                  colors.filter((value, index) => {
                    if(value === color) colors.splice(index, 1);
                  });
                })
              }
              post.remove();
              const index = posts.indexOf(post);
              if (index > -1) {
                posts.splice(index, 1);
              }
            }
          });
        }
        if(colors.length) {
          colors.forEach((color) => {
            const matrix = new WebKitCSSMatrix(window.getComputedStyle(color).transform);
            const param = matrix.m41 + parseFloat(color.getAttribute('data-ratio'));
            color.style.transform = `translateX(${param}px) translateZ(0)`;
          });
        }
      }
      requestAnimationFrame(animatePosts);
    }

    const changeVirtualGallery = (isNext = true) => {
      if (isNext) {
        current = current == randomsNum ? 0 : current + 1;
      } else {
        current = current == 0 ? randomsNum : current - 1;
      }
      const currentObj = images_json.images[randoms[current]];
      createPost(currentObj);
    }

    let lastInnerWidth = window.innerWidth;
    window.addEventListener('resize', () => {
      if(lastInnerWidth != window.innerWidth) {
        lastInnerWidth = window.innerWidth;
        ww = window.document.documentElement.clientWidth;
        [adjustedMinSize, adjustedMaxSize] = getRange(minSize, maxSize, '', '', ww, baseWidth, minSizeRatio, maxSizeRatio);
        [adjustedMinSpeed, adjustedMaxSpeed] = getRange(minSpeed, maxSpeed, '', '', ww, baseWidth, minSpeedRatio, maxSpeedRatio);
        [adjustedMinTiming, adjustedMaxTiming] = getRange(minTiming, maxTiming, minTimingLimit, maxTimingLimit, ww, baseWidth, minTimingRatio, maxTimingRatio);
        posts.forEach((post) => {
          post.setAttribute('data-ratio', customRandom(adjustedMinSpeed, adjustedMaxSpeed, 3))
          post.setAttribute('data-width', post.clientWidth)
        })
      }
    })

    let focus = false;
    window.addEventListener('focus', () => {
      focus = true;
    })
    window.addEventListener('blur', () => {
      focus = false;
    })

    const virtualGalleryInit = () => {
      for (let i = 0; i <= randomsNum; i++) {
        let tmp;
        do {
          tmp = intRandom(0, randomsNum);
        } while (randoms.includes(tmp));
        randoms.push(tmp);
      }

      focus = true;
      
      const virtualGalleryCicle = () => {
        if(focus && isAnimate) {
          changeVirtualGallery();
        }
        const int = intRandom(adjustedMinTiming, adjustedMaxTiming)
        setTimeout(virtualGalleryCicle, int);
      }

      document.body.classList.add('is-init-home')
      virtualGalleryCicle();
      animatePosts();
      animateActiveColor();
    }

    virtualGalleryInit();
  }
}